/* form-header.tsx generated by @compiled/babel-plugin v0.36.1 */
/* eslint-disable @atlaskit/design-system/use-primitives */
import "./form-header.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import Heading from '@atlaskit/heading';
var formHeaderContentStyles = null;
var formHeaderDescriptionStyles = null;

/**
 * __Form header__.
 *
 * A form header contains the form component's heading and subheadings. This provides the correct padding
 * and styling for it.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */
var FormHeader = function FormHeader(_ref) {
  var children = _ref.children,
    description = _ref.description,
    title = _ref.title;
  return /*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement(Heading, {
    size: "large"
  }, title), description && /*#__PURE__*/React.createElement("div", {
    className: ax(["_1pfhu2gc"])
  }, description), children && /*#__PURE__*/React.createElement("div", {
    className: ax(["_1ul91osq _1pfhu2gc"])
  }, children));
};
export default FormHeader;